/*
 * ws-sticky-cart-sync.js
 * WEITSICHT — Synchronisiert Custom-Felder (properties[...]) zwischen dem
 * Haupt-Produktformular und der mobilen/klebenden "Sticky Add-to-Cart"-Leiste.
 *
 * Problem: Custom-Felder (z.B. Becherdurchmesser, Datei-Upload) sind nur ans
 * Hauptformular (id="product-form-<section>") gebunden. Die Sticky-Leiste nutzt
 * ein eigenes Formular (id="sticky-addcart-form-<section>"). Beim Kauf ueber die
 * Sticky-Leiste (auf Mobile Standard) werden diese Felder NICHT mitgeschickt
 * -> Masse & Datei fehlen in der Bestellung (siehe Bestellung #1139).
 *
 * Loesung: Alle Custom-Felder werden bidirektional in beide Formulare gespiegelt
 * (Text/Zahl/Textarea/Select/Checkbox/Radio + File-Uploads via DataTransfer).
 * Vor jedem Submit (Haupt- ODER Sticky-Form) werden alle Pflichtfelder validiert.
 *
 * Wichtig: Das Hauptformular wird NICHT per querySelector gesucht (auf der Seite
 * existieren weitere Formulare mit Prefix "product-form-", z.B. in verwandten
 * Produkten). Stattdessen wird das echte Formular ueber das form="..."-Attribut
 * der Custom-Felder bestimmt und das Sticky-Pendant ueber die gleiche Section-ID
 * abgeleitet. Laeuft als No-Op, wenn keine Custom-Felder vorhanden sind.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  // Leicht verzoegern, damit App-/Theme-Bloecke ihre Felder gerendert haben.
  ready(function () { setTimeout(init, 300); });

  var PROP_SELECTOR = '[name^="properties["]';
  var MAIN_PREFIX = 'product-form-';
  var STICKY_PREFIX = 'sticky-addcart-form-';

  function cssEscape(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/["\\\]\[]/g, '\\$&');
  }
  function isFile(el) { return el && el.type === 'file'; }

  // WICHTIG: Shopify-Formulare enthalten <input name="id"> (Varianten-ID).
  // Dadurch wird form.id vom Element ueberschrieben ("DOM clobbering") und ist
  // KEIN String mehr. Deshalb IMMER getAttribute('id') verwenden.
  function formId(form) {
    return form && form.getAttribute ? (form.getAttribute('id') || '') : '';
  }

  // Ermittelt das Formular, zu dem ein Feld gehoert (form="id" ODER Elternform).
  function ownerForm(el) {
    var fid = el.getAttribute('form');
    if (fid) { var f = document.getElementById(fid); if (f) return f; }
    return el.form || el.closest('form');
  }

  function init() {
    // 1) Alle echten (nicht gespiegelten) Custom-Felder einsammeln.
    var allProps = Array.prototype.slice
      .call(document.querySelectorAll(PROP_SELECTOR))
      .filter(function (el) { return !el.hasAttribute('data-ws-mirror'); });
    if (!allProps.length) return;

    // 2) Nach zugehoerigem Hauptformular gruppieren. Nur Felder beruecksichtigen,
    //    deren Formular-ID mit dem Haupt-Prefix beginnt (die eigentlichen
    //    Produkt-Optionsfelder). So treffen wir NIE ein fremdes Formular.
    var groups = {}; // mainFormId -> { main: form, fields: [] }
    allProps.forEach(function (el) {
      var f = ownerForm(el);
      var fid = formId(f);
      if (!fid || fid.indexOf(MAIN_PREFIX) !== 0) return;
      if (!groups[fid]) groups[fid] = { main: f, fields: [] };
      groups[fid].fields.push(el);
    });

    Object.keys(groups).forEach(function (mainId) {
      setupPair(groups[mainId].main, groups[mainId].fields);
    });
  }

  function setupPair(mainForm, mainFields) {
    // Sticky-Pendant ueber dieselbe Section-ID ableiten.
    var suffix = formId(mainForm).slice(MAIN_PREFIX.length);
    var stickyForm = document.getElementById(STICKY_PREFIX + suffix);

    // Falls es im Sticky-Formular eigene Custom-Felder gibt -> ebenfalls sammeln.
    var stickyFields = [];
    if (stickyForm) {
      Array.prototype.slice.call(stickyForm.querySelectorAll(PROP_SELECTOR))
        .forEach(function (el) { if (!el.hasAttribute('data-ws-mirror')) stickyFields.push(el); });
      document.querySelectorAll(PROP_SELECTOR).forEach(function (el) {
        if (el.getAttribute('form') === formId(stickyForm) && !el.hasAttribute('data-ws-mirror')) {
          if (stickyFields.indexOf(el) === -1) stickyFields.push(el);
        }
      });
    }

    var mirrors = {}; // targetFormId::name -> mirror element

    function ensureMirror(targetForm, srcEl) {
      if (!targetForm) return null;
      var name = srcEl.getAttribute('name');
      var key = formId(targetForm) + '::' + name;
      if (mirrors[key]) return mirrors[key];

      // Vorhandenes echtes Feld im Ziel bevorzugen.
      var existing = Array.prototype.slice
        .call(targetForm.querySelectorAll('[name="' + cssEscape(name) + '"]'))
        .filter(function (e) { return !e.hasAttribute('data-ws-mirror'); })[0];
      if (existing) { mirrors[key] = existing; return existing; }

      var mirror = document.createElement('input');
      if (isFile(srcEl)) {
        mirror.type = 'file';
        if (srcEl.multiple) mirror.multiple = true;
        mirror.style.display = 'none';
        mirror.tabIndex = -1;
        mirror.setAttribute('aria-hidden', 'true');
      } else {
        mirror.type = 'hidden';
      }
      mirror.name = name;
      mirror.setAttribute('data-ws-mirror', '1');
      targetForm.appendChild(mirror);
      mirrors[key] = mirror;
      return mirror;
    }

    function syncInto(targetForm, srcEl) {
      if (!targetForm) return;
      if (ownerForm(srcEl) === targetForm) return; // nicht in eigenes Form spiegeln
      var mirror = ensureMirror(targetForm, srcEl);
      if (!mirror || mirror === srcEl) return;

      if (isFile(srcEl)) {
        try {
          var dt = new DataTransfer();
          if (srcEl.files) { for (var i = 0; i < srcEl.files.length; i++) dt.items.add(srcEl.files[i]); }
          mirror.files = dt.files;
        } catch (e) { /* aeltere Browser */ }
      } else if (srcEl.type === 'checkbox' || srcEl.type === 'radio') {
        mirror.value = srcEl.value;
        mirror.disabled = !srcEl.checked;
      } else {
        mirror.value = srcEl.value;
      }
    }

    function wire(fields, targetForm) {
      if (!targetForm) return;
      fields.forEach(function (el) {
        syncInto(targetForm, el);
        var h = function () { syncInto(targetForm, el); };
        el.addEventListener('input', h);
        el.addEventListener('change', h);
      });
    }

    if (stickyForm) {
      wire(mainFields, stickyForm);   // Haupt -> Sticky
      wire(stickyFields, mainForm);   // Sticky -> Haupt
    }

    // ---- Validierung --------------------------------------------------------
    function validate() {
      var fields = mainFields.concat(stickyFields);
      var ok = true, firstBad = null;
      fields.forEach(function (el) {
        if (!el.required) return;
        var valid = isFile(el)
          ? (el.files && el.files.length > 0)
          : (el.value != null && String(el.value).trim() !== '');
        if (valid && typeof el.checkValidity === 'function' && !el.checkValidity()) valid = false;
        if (!valid) { ok = false; if (!firstBad) firstBad = el; }
      });
      if (!ok && firstBad) {
        try { firstBad.dispatchEvent(new Event('invalid')); } catch (e) {}
        if (typeof firstBad.reportValidity === 'function') { try { firstBad.reportValidity(); } catch (e) {} }
        try { firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        if (typeof firstBad.focus === 'function') { try { firstBad.focus({ preventScroll: true }); } catch (e) {} }
      }
      return ok;
    }

    function guard(form) {
      if (!form) return;
      var intercept = function (e) {
        // Werte frisch spiegeln (beide Richtungen), dann validieren.
        if (stickyForm) { mainFields.forEach(function (el) { syncInto(stickyForm, el); }); }
        stickyFields.forEach(function (el) { syncInto(mainForm, el); });
        if (!validate()) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          return false;
        }
      };
      // Capture-Phase: laeuft VOR dem Theme-Handler, der FormData(form) baut.
      form.addEventListener('submit', intercept, true);
      var btn = form.querySelector('[type="submit"], button[name="add"], .product-form__submit');
      if (btn) btn.addEventListener('click', intercept, true);
    }

    guard(mainForm);
    guard(stickyForm);

    // Spaeter per App eingefuegte Felder nachtraeglich verdrahten.
    try {
      var mo = new MutationObserver(function () {
        var fresh = Array.prototype.slice.call(document.querySelectorAll(PROP_SELECTOR))
          .filter(function (el) {
            if (el.hasAttribute('data-ws-mirror')) return false;
            return ownerForm(el) === mainForm && mainFields.indexOf(el) === -1;
          });
        if (fresh.length && stickyForm) {
          fresh.forEach(function (el) { mainFields.push(el); });
          wire(fresh, stickyForm);
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* optional */ }
  }
})();
